import { render, staticRenderFns } from "./NewConsole.vue?vue&type=template&id=2ab131b9&scoped=true&"
import script from "./NewConsole.vue?vue&type=script&lang=js&"
export * from "./NewConsole.vue?vue&type=script&lang=js&"
import style0 from "./NewConsole.vue?vue&type=style&index=0&id=2ab131b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab131b9",
  null
  
)

export default component.exports